<template>
  <div id="store-info-container" class="mt-2 mb-4">
    <div class="store-container">
      <div class="location-area">
    <SingleStoreMap :store="store"></SingleStoreMap>
    <div class="place-detail-area">
    <div class="cap1-area d-flex pd-15">
      <div
          class="heart-area active c-pointer"
          v-if="selected_location"
      >
        <i aria-hidden="true" class="fa fa-heart"></i>
        <p>My</p>
        <p>Store</p>
      </div>
      <div
          class="heart-area c-pointer"
          v-else
          @click.stop="setStore()"
      >
        <i aria-hidden="true" class="fa fa-heart-o"></i>
        <p>Set as</p>
        <p>My Store</p>
      </div>
      <div class="property flex-1">
        <div class="lbl-1">
          {{ store.address.city }},
          {{ store.address.region }}
          <span class="lbl-1-sub store-desktop"
          >(Store #{{store["location-id"] }})</span
          >
        </div>
        <div class="lbl-1-sub store-mobile md-b10 "
        >(Store #{{store["location-id"] }})
        </div>
        <div class="lbl-info md-b10 store-desktop">
          {{ store.address.street }},
          {{ store.address.city }},
          {{ store.address.region }}
          {{ store.address.postalCode }}
        </div>
        <div class="d-flex flex-column lbl-info md-b10 store-mobile">
          <span>{{ store.address.street }}, </span>
          <span>{{ store.address.city }}, {{ store.address.region }} {{ store.address.postalCode }}</span>
        </div>
        <div class="p-distance lbl-info store-desktop">
                        <span class="c-blue c-pointer">
                          {{store.mainPhone }}
                        </span> | {{store.distance.distanceMiles.toFixed(1)}} Miles |
                        <span class="c-blue c-pointer" @click.stop="goToNewTabLink(store.directionsURL)">Get Directions</span>
        </div>
        <div class="p-distance d-flex flex-column lbl-info store-mobile">
                        <span class="c-blue c-pointer md-b10">{{store.mainPhone }}</span>
          <div class="md-b10">{{store.distance.distanceMiles.toFixed(1)}} Miles |
            <span class="c-blue c-pointer" @click.stop="goToNewTabLink(store.directionsURL)">Get Directions</span>
          </div>
          <!-- @TODO - May want to disable the map for this view, we'll see output and layout -->
          <div class="switch-map md-b10 store-mobile">
            <span>Map</span>
            <b-form-checkbox v-model="map_checked" name="check-button" switch></b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div v-if="map_checked" class="store-mobile">
      <gmap-map
          :center="center"
          :zoom="6"
          style="width: 100%; height: 400px; margin-bottom: 15px;"
      >
        <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="center = m.position"
        ></gmap-marker>
      </gmap-map>
    </div>
    <div class="place-property">
      <div class="w170 bk-grey">
        <div class="c-green lbl-info t-bold md-b10">
          Open Until {{ store.currentHours }}
        </div>
        <div v-html="showHours(store.hours)" class="day-available"></div>
      </div>
      <div class="store-amenity flex-1 bk-grey">
        <div class="lbl-info t-bold md-b10">
          Store Amenities & Specialties:
        </div>
        <div class="place-service">
          <div class="service-row">
            <img src="../../assets/img/icon_anchor.png" alt="" />
            <span class="lbl-info">Marine Services</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_wrench.png" alt="" />
            <span class="lbl-info">Auto Repair Services</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_truck.png" alt="" />
            <span class="lbl-info">Oversized Vehicles</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_handcap.png" alt="" />
            <span class="lbl-info">Accessible</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_wifi.png" alt="" />
            <span class="lbl-info">Free Wifi</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_coffee.png" alt="" />
            <span class="lbl-info">Free Coffee & Snacks</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_moon.png" alt="" />
            <span class="lbl-info">Overnight Drop-Off</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_pet.png" alt="" />
            <span class="lbl-info">Pet Friendly</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-actions">
      <div
          class="btn-custom mw-200 disable"
          @click.stop="gotoBack('place')"
      >
        <i aria-hidden="true" class="fa fa-angle-left"></i>
        <span>Back to Store Search</span>
      </div>
      <div
          @click.stop="gotoLink(store.websiteUrl)"
          class="btn-custom mw-200 bk-blue"
      >
        <span class="store-detail-link">Store Details & Offers</span>
        <i aria-hidden="true" class="fa fa-angle-right"></i>
      </div>
    </div>
    </div>
        </div>
      </div>
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import SingleStoreMap from '@/components/partials/SingleStoreMap.vue'
export default {
  components: {
    SingleStoreMap
  },
  props: {
    store: Object
  },
  computed: {
    google: gmapApi,
    selectedLocation(){
      if(this.$store.getters.formStore){
        return this.$store.getters.formStore['location-id'];
      }
      return false;
    },
    selected_location: {
      get(){
        //@TODO - Solidify this concept / setup of MyStore for Nav
        return this.$store.state.myStore;
        //if(this.$store.getters.formStore){
          //return this.$store.getters.formStore['location-id'];

        //}
        //return false;
      },
      set(){
        this.$emit('setStore',this.store.id);
      }
    },
  },
  data: () => {
    return {
      map_checked: false
    }
  },
  created() {

  },
  methods: {
    setStore(){
      //@TODO - Double Check Correct Property Below
      this.$emit('setStore',this.store.id);
    },
    formatDay(day){
      return day.substring(0,3)
    },
    convertTime(strTime){
      //  08:00
      let time_h = parseInt(strTime.substring(0,2))
      if(time_h > 12) {
        time_h = time_h - 12
        if(time_h > 9) {
          return time_h + 'pm'
        }else{
          return time_h + 'pm'
        }
      }else{
        if(time_h > 9) {
          return time_h + 'am'
        }else{
          return time_h + 'am'
        }
      }

    },
    formatHour(hours){
      if(hours['openIntervals']){
        var tx = hours['openIntervals'][0]
        return this.convertTime(tx.start) + ' - ' + this.convertTime(tx.end)
      }else if(hours['isClosed']){
        return 'Closed'
      }else{
        return ''
      }

    },
    showHours(data) {
      var html = ''
      for (const [key, value] of Object.entries(data)) {
        // console.log(key, value);
        if(key !== 'holidayHours'){
          html += '<div class="d-flex flex-row md-b2">'
          html += '<span class="lbl-info t-bold w65 t-cap">'+this.formatDay(key)+'</span><span class="lbl-info">'+this.formatHour(value)+'</span>'
          html += '</div>'
        }
      }
      return html
    },
    gotoLink(url) {
      if(url !== '') location.href = url;
    },
    goToNewTabLink(url){
      if(url !== '') window.open(url,'_blank');
    },
    gotoBack(){
      this.$emit('clearStore');
    }
  }
}
</script>
<style>
#store-info-container {

}
#store-info-container .location-area {
  max-width:100%;
  min-width:320px;
}
@media(max-width:767px){
  #store-info-container .store-container .location-area .place-detail-area .place-service {
    height:auto;
  }
  #store-info-container .store-container .location-area .place-detail-area .day-available {
    height:auto;
  }
  #store-info-container .store-container .location-area .place-detail-area .bk-grey {
    height:auto;
  }
  #store-info-container .store-container .location-area .place-detail-area .bk-grey {
    text-align:center;
  }
  #store-info-container .store-container .location-area .place-detail-area .bk-grey .md-b2 {
    justify-content: center;
  }
  #store-info-container .store-container .location-area .place-detail-area .place-service .service-row {
    justify-content: center;
  }
}
@media(min-width:992px){
  #store-info-container .location-area {
    max-width: 100%;
    flex-direction: row;
    width: 100%;
  }
  #store-info-container .place-detail-area {
    min-width:600px;
  }
}
#store-info-container .place-detail-area {
  order:1;
}
#store-info-container .store-container {
  border:solid 1px #999;
}
@media(max-width:850px){
  #store-info-container .store-mobile{display: none !important;}
  #store-info-container .store-desktop{display: inline-block !important;}
}
@media screen and (max-width: 475px){

}
</style>